import request from '@/utils/request'
import jwt_decode from 'jwt-decode'
import UserConfigService from '@/services/user_config_service';
import { AdUserEntity } from "@/services/data/user_manager";
import { AxiosResponse } from "axios";

export enum AuthCheck {
  OK = 'ok',
  INIT_ADMIN = 'init_admin',
  LOGIN = 'login'
}

export interface IAuthCheckResponse {
  status: AuthCheck,
  heat_node_ids?: number[],
}

class AuthService {

  public first_init = true;
  private configService: any;


  constructor() {
    this.configService = UserConfigService;

  }

  setFirstInit(val: boolean) {
    this.first_init = val;
  }

  saveUserToken(token: string) {
    const decoded: any = this.decode_token(token);
    if (!decoded) {
      return;
    }
    localStorage.setItem('access_token', token)
    localStorage.setItem('token_exp_at', decoded.exp)
    localStorage.setItem('user_id', decoded.sub)
    localStorage.setItem('user_name', decoded.user_metadata.full_name)
    localStorage.setItem('user_role', decoded.role)

    this.setHeatNodeIds(decoded.heat_node_ids);

    this.setFirstInit(true);
  }

  setHeatNodeIds(ids: number[]) {
    // Сохранить список идентификаторов пользователя
    if (ids) {
      localStorage.setItem('heat_node_ids', JSON.stringify(ids))
    }
  }

  getUserIdFromToken() {
    const token = localStorage.getItem('access_token')
    if (token) {
      const decoded: any = this.decode_token(token);
      if (decoded) {
        return decoded.sub;
      }
    }
    return null;
  }

  getUserName() {
    return localStorage.getItem('user_name') || ''
  }

  getUserId(): string {
    return localStorage.getItem('user_id') || ''
  }

  resetToken() {
    localStorage.removeItem('access_token')
    localStorage.removeItem('token_exp_at')
    localStorage.removeItem('user_id')
    localStorage.removeItem('user_name')
    localStorage.removeItem('user_role')
    localStorage.removeItem('heat_node_ids')
  }


  decode_token(token: string) {
    if (!token) {
      return null
    }

    try {
      return jwt_decode(token)
    } catch (e) {
      return null
    }
  }

  getToken() {
    return localStorage.getItem('access_token') || ''
  }

  getRole() {
    return localStorage.getItem('user_role') || '';
  }

  isAdmin() {
    return this.getRole() === 'admin';

  }

  isOperator() {
    return this.getRole() === 'operator';

  }

  isHeatNodeOperator() {

    let heat_node_ids = localStorage.getItem('heat_node_ids');
    return !this.isAdmin();
  }

  // Возвращает True в режиме аутентификации через Active Directory
  isActiveDirectoryAuth() {
    // @ts-ignore
    return config.VUE_APP_AD_AUTH || false;
  }

  getHeatNodeId(): number[] {
    const heatNodesStringArray = localStorage.getItem('heat_node_ids') || null;
    return heatNodesStringArray ? JSON.parse(heatNodesStringArray) : [];
  }

  get adminRoleId() {
    return 'bc91ad0b-75aa-42ec-8f51-116e6e29c8c0'
  }

  login(data: any, timeout = 15000) {

    return request({
      url: '/auth/auth_by_login',
      method: 'post',
      data,
      timeout,
    })
  }

  loginAD(data: any, timeout = 15000) {

    return request({
      url: '/auth/login',
      method: 'post',
      data,
      timeout,
    })
  }

  // Запрос на получение доступа к инициализации администратора
  async initAdminCheck(search_str: string | null = null): Promise<AdUserEntity[]>  {
    const resp: AxiosResponse["data"] = await request({
      url: '/auth/init_admin',
      method: 'post',
      data: { search_str },
      timeout: 30000
    });
    return resp.data ? resp.data : [];
  }

  // Запрос инициализации администратора
  initAdminConfirm(data: any) {
    return request({
      url: `/auth/init_admin`,
      method: 'put',
      data,
    })
  }

  async checkLogged():Promise<IAuthCheckResponse> {

    const resp: AxiosResponse["data"] = await request({
      url: '/auth/validate',
      method: 'get',
    })
    if (resp.status && Object.values(AuthCheck).includes(resp.status)) {
      return resp
    }
    return { status: AuthCheck.OK };
  }

  async logout() {
    await request({
      url: '/auth/logout',
      method: 'get'
    });
    this.resetToken();
    this.setFirstInit(true);
  }
}

export default new AuthService();
